var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import * as constant from '../../constant/common-type';
import { exportData } from '../../utils/common-export-polling';
import searchModel from '../../components/console-common/search-model.vue';
import eventBus from '../../utils/fresh-table';
import checkVehicleInfoModal from '../../components/vehicle-manage/check-vehicle.vue';
import editVehicleInfoModal from '../../components/vehicle-manage/edit-vehicle.vue';
import contractCard from '../../components/console-common/contract-board.vue';
import contractView from '../../components/contract/contract-view.vue';
export default Vue.extend({
    components: {
        'el-search-model': searchModel,
        'el-check-vehicle-info': checkVehicleInfoModal,
        'el-edit-vehicle-info': editVehicleInfoModal,
        'el-contract-card': contractCard,
        'el-contract-view': contractView,
    },
    mounted: function () { },
    data: function () {
        var _this = this;
        return {
            dialogFormVisible: false,
            defaultSearch: {
                dateType: 'purchaseTime',
            },
            constant: constant,
            requestConfig: {
                storeName: 'vehicle/GET_VEHICLE_LIST',
                params: {
                    pageNo: 1,
                    pageSize: 20,
                },
            },
            searchConfig: [
                {
                    label: '车牌号',
                    key: 'licensePlateNumber',
                    type: 'searchInput',
                    placeholder: '请输入',
                    searchType: 'LICENSEPLATENUMBER',
                    url: 'vehicle/GET_DRIVEROPERATOR_LIST',
                },
                {
                    label: '车架号',
                    key: 'vehicleIdentificationNumber',
                    type: 'searchInput',
                    placeholder: '请输入',
                    searchType: 'IDENTIFICATIONNUMBERMODEL',
                    url: 'vehicle/GET_DRIVEROPERATOR_LIST',
                },
                {
                    label: '发动机号',
                    key: 'engineNumber',
                    type: 'searchInput',
                    placeholder: '请输入',
                    searchType: 'ENGINENUMBERMODEL',
                    url: 'vehicle/GET_DRIVEROPERATOR_LIST',
                },
                {
                    label: '车辆型号',
                    key: 'vehicleModel',
                    type: 'searchInput',
                    placeholder: '请输入',
                    searchType: 'VEHICLEMODEL',
                    url: 'vehicle/GET_DRIVEROPERATOR_LIST',
                },
                {
                    label: '车辆状态',
                    key: 'status',
                    type: 'select',
                    option: constant.vehicleStatusOptions,
                },
                {
                    label: '车辆用途',
                    key: 'purpose',
                    type: 'select',
                    option: constant.purposeOptions,
                },
                {
                    label: '颜色',
                    key: 'color',
                    type: 'color',
                    option: constant.colorOptions,
                },
                {
                    label: '油电性质',
                    key: 'powered',
                    type: 'select',
                    option: constant.poweredOptions,
                },
                {
                    label: '所属公司',
                    key: 'subjection',
                    type: 'searchInput',
                    placeholder: '',
                    searchType: 'SIGNCOMPANY',
                    url: 'vehicle/GET_DRIVEROPERATOR_LIST',
                },
                {
                    label: '经办人',
                    key: 'operator',
                    type: 'searchInput',
                    placeholder: '请输入',
                    searchType: 'VEHICLEOPERATOR',
                    url: 'vehicle/GET_DRIVEROPERATOR_LIST',
                },
                {
                    key: 'dateType',
                    dateKey: 'selectDate',
                    valueFormat: 'yyyy-MM-dd HH:mm:ss',
                    selfDateType: 'daterange',
                    dateTypes: {
                        purchaseTime: ['purchaseTimeStart', 'purchaseTimeEnd'],
                        licenseTime: ['licenseTimeStart', 'licenseTimeEnd'],
                    },
                    type: 'selectDate',
                    option: [
                        {
                            label: '购置日期',
                            val: 'purchaseTime',
                        },
                        {
                            label: '上牌日期',
                            val: 'licenseTime',
                        },
                    ],
                },
                {
                    type: 'noSelectdateRange',
                    key: 'createTime',
                    dateKeys: ['createTimeStart', 'createTimeEnd'],
                    label: '导入日期',
                },
            ],
            btns: [
                {
                    name: '查看',
                    callback: function (row) {
                        _this.handleCheck(row.vehicleCode, 'check');
                    },
                    formatter: function () {
                        return true;
                    },
                    border: function () {
                        return true;
                    },
                },
                {
                    name: '编辑',
                    callback: function (row) {
                        _this.handleCheck(row.vehicleCode, 'edit');
                    },
                    formatter: function (val) {
                        return val.status !== 'DISPOSED';
                    },
                    border: function (val) {
                        if (val) {
                            return val.status === 'INVENTORY';
                        }
                    },
                },
                {
                    name: '设为在库',
                    callback: function (row) {
                        _this.updateVehicleState(row);
                    },
                    formatter: function (val) {
                        return val.status === 'DISPOSED';
                    },
                    border: function () {
                        return false;
                    },
                },
                {
                    type: 'more',
                    border: function () {
                        return false;
                    },
                    formatter: function (val) {
                        return val.status === 'INVENTORY';
                    },
                    moreBtns: [
                        {
                            name: '设为已处置',
                            className: 'self_normal_btn',
                            callback: function (row) {
                                _this.updateVehicleState(row);
                            },
                            formatter: function (val) {
                                return val.status === 'INVENTORY';
                            },
                        },
                        {
                            name: '删除',
                            className: 'self_delete_btn',
                            callback: function (row) {
                                _this.deleteVehicle(row.vehicleCode);
                            },
                            formatter: function (val) {
                                return val.status === 'INVENTORY';
                            },
                        },
                    ],
                },
            ],
        };
    },
    computed: __assign({}, mapState('vehicle', [
        'vehicleList',
        'showVehicleCheckDialog',
        'showVehicleEditDialog',
    ]), { maxHeight: function () {
            return window.innerHeight - 164;
        } }),
    methods: {
        getContract: function (list) {
            var _this = this;
            var array = [];
            if (list && list.length) {
                list.forEach(function (ele) {
                    var obj = {
                        orderNo: '',
                        status: '',
                        list: [],
                    };
                    obj.orderNo = ele.contractCode;
                    obj.status = ele.contractProcess;
                    obj.list = [
                        {
                            key: '司机姓名',
                            val: ele.driverName,
                        },
                        {
                            key: '车牌号',
                            val: ele.plateNumber,
                            push: 4,
                        },
                        {
                            key: '注册手机号',
                            val: ele.driverMobile,
                            span: 24,
                        },
                        {
                            key: '业务模式',
                            val: constant.leaseMode[ele.leaseMode],
                        },
                        {
                            key: '租金',
                            val: "\uFFE5" + _this.$utils.toYuan(ele.monthlyPayment),
                            push: 4,
                        },
                        {
                            key: '合同有效期',
                            val: moment(ele.startTime).format('YYYY-MM-DD') + " \u81F3 " + moment(ele.endTime).format('YYYY-MM-DD'),
                            span: 24,
                        },
                    ];
                    array.push(obj);
                });
            }
            return array;
        },
        sizeChange: function (val) {
            this.requestConfig.params = {
                pageSize: val,
                pageNo: this.vehicleList.pageNo,
            };
            this.$refs.searchModel.filter();
        },
        currentChange: function (val) {
            this.requestConfig.params = {
                pageNo: val,
                pageSize: this.vehicleList.pageSize,
            };
            this.$refs.searchModel.filter();
        },
        getTabelList: function (params) {
            this.$store.dispatch('vehicle/GET_VEHICLE_LIST', __assign({}, params));
        },
        handleCheck: function (vehicleCode, type) {
            this.$store.dispatch('vehicle/GET_VEHICLE_DETAIL_INFO', {
                vehicleCode: vehicleCode,
                type: type,
            });
        },
        updateVehicleState: function (row) {
            var _this = this;
            var title = row.status === 'INVENTORY'
                ? '您确认要将该车辆状态变更为已处置吗？'
                : '您确认要将该车辆状态变更为在库吗？';
            var selfstate = row.status === 'INVENTORY' ? 'DISPOSED' : 'INVENTORY';
            this.$confirm('', '', {
                message: "<p class=\"title\">" + title + "</p>",
                dangerouslyUseHTMLString: true,
                showClose: true,
                confirmButtonText: '确 定',
                cancelButtonText: '取 消',
                type: 'warning',
            })
                .then(function () {
                _this.$request({
                    url: '/proxy/vehicle/driver/vehicle/update/status',
                    method: 'post',
                    data: {
                        status: selfstate,
                        vehicleCode: row.vehicleCode,
                    },
                }).then(function (res) {
                    if (!res.errorCode) {
                        _this.$message({
                            message: '设置成功',
                            type: 'success',
                        });
                        eventBus.$emit('freshTable');
                    }
                    else {
                        _this.$message.error(res.errorMsg);
                    }
                });
            })
                .catch(function () { });
        },
        deleteVehicle: function (vehicleCode) {
            var _this = this;
            this.$confirm('', '', {
                message: '<p class="title">您确认要删除该车辆吗？</p>',
                dangerouslyUseHTMLString: true,
                showClose: true,
                confirmButtonText: '删 除',
                cancelButtonText: '取 消',
                type: 'warning',
                customClass: 'self-confirm delete-confirm',
            })
                .then(function () {
                _this.$request({
                    url: '/proxy/vehicle/driver/vehicle/delete',
                    method: 'post',
                    data: {
                        vehicleCode: vehicleCode,
                    },
                }).then(function (res) {
                    if (!res.errorCode) {
                        _this.$message({
                            message: '删除成功',
                            type: 'success',
                        });
                        eventBus.$emit('freshTable');
                    }
                    else {
                        _this.$message.error(res.errorMsg);
                    }
                });
            })
                .catch(function () { });
        },
        exportExcel: function () {
            var params = this.$refs.searchModel.searchForm;
            exportData({
                keyUrl: '/proxy/vehicle/driver/vehicle/export',
                statusUrl: '/proxy/api/getFileUrl',
                params: params,
            });
        },
        moment: function (date) {
            // 格式化日期
            if (date) {
                return moment(date).format('YYYY-MM-DD');
            }
            else {
                return '--';
            }
        },
    },
});
